(function () {
  function initCpTestimonials(sectionEl) {
    var sectionId = sectionEl.id;
    var $slider = jQuery('#' + sectionId + ' .cp-testimonials-track');
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;

    var slidesToShow = parseInt(sectionEl.dataset.slidesToShow, 10) || 4;
    var slidesToShowTablet = parseInt(sectionEl.dataset.slidesToShowTablet, 10) || 3;
    var autoplay = sectionEl.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(sectionEl.dataset.autoplaySpeed, 10) || 5000;

    $slider.slick({
      infinite: false,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 500,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      prevArrow: jQuery('#' + sectionId + ' .cp-testimonials-prev'),
      nextArrow: jQuery('#' + sectionId + ' .cp-testimonials-next'),
      responsive: [
        {
          breakpoint: 1025,
          settings: { slidesToShow: slidesToShowTablet }
        },
        {
          breakpoint: 601,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  }

  function boot(sectionEl) {
    function run() {
      initCpTestimonials(sectionEl);
    }

    if (window.loadSlick) {
      window.loadSlick(run);
    } else if (window.jQuery && jQuery.fn.slick) {
      run();
    }
  }

  function bootAll() {
    document.querySelectorAll('.cp-testimonials-section [id^="cp-testimonials-"]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Re-init inside the theme editor after block edits
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector('[id^="cp-testimonials-"]');
    if (sectionEl) boot(sectionEl);
  });
})();
